const listCustomErrorsMessage: { [key: string]: string } = {
  "error.asset.not-ready": "This game doesn’t have assets to download",
  "error.asset.empty": "This game doesn’t have assets to download",
  "error.promo-pack.not-ready": "This game doesn’t have promo pack to download",
  "error.promo-pack.empty": "This game doesn’t have promo pack to download",
};

export const getErrorMessageFromCode = (code?: string) => {
  if (code && listCustomErrorsMessage[code]) {
    return listCustomErrorsMessage[code];
  }

  return null;
};
